import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getStoreLocationsList(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.BUSINESS.STORE_LOCATIONS_LIST, action.payload, true);
}

export function* insertUpdateStoreLocation(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.BUSINESS.STORE_LOCATIONS_INSERT_UPDATE, action.payload, true);
}